var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBitbucket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.51381 0.799807C0.439401 0.799605 0.365841 0.815607 0.298244 0.846699C0.230647 0.877792 0.170634 0.923229 0.122377 0.979852C0.0741196 1.03648 0.0387764 1.10293 0.0188041 1.17458C-0.00116831 1.24624 -0.00529059 1.32139 0.0067236 1.3948L2.17919 14.6181C2.20823 14.7775 2.2917 14.9218 2.41534 15.0264C2.53897 15.131 2.69511 15.1895 2.85708 15.1918H13.3244C13.4464 15.1915 13.5644 15.1479 13.6573 15.0687C13.7502 14.9895 13.8119 14.88 13.8315 14.7596L15.9933 1.39747C16.0053 1.32406 16.0012 1.24891 15.9812 1.17725C15.9612 1.10559 15.9259 1.03914 15.8776 0.98252C15.8294 0.925897 15.7694 0.88046 15.7018 0.849368C15.6342 0.818275 15.5606 0.802273 15.4862 0.802475L0.51381 0.799807ZM9.68406 10.3571H6.33462L5.44322 5.63983H10.4927L9.68406 10.3571Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.31 5.64014H10.5061L9.70539 10.3574H6.3346L2.40869 15.032C2.53358 15.1393 2.69243 15.1988 2.85706 15.2001H13.3244C13.4464 15.1998 13.5644 15.1562 13.6573 15.077C13.7501 14.9979 13.8119 14.8883 13.8315 14.7679L15.31 5.64014Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16.4229,
    y1: 6.96087,
    x2: 8.46334,
    y2: 13.1744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitbucket);
export default __webpack_public_path__ + "static/media/bitbucket.46cefd2ed035f5f0ded25cde69156375.svg";
export { ForwardRef as ReactComponent };